import React, { useCallback, useEffect, useState } from 'react';
import QRCode from 'qrcode';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import alert from '../../helpers/alert';
import { socket } from '../../App';
import createClientUploadLink from '../../api/clientUpload/createClientUploadLink';
import getClientUploadStatus from '../../api/clientUpload/getClientUploadStatus';
import sendClientUploadSms from '../../api/clientUpload/sendClientUploadSms';
import revokeClientUploadLink from '../../api/clientUpload/revokeClientUploadLink';
import {
  ALL_KINDS,
  CLIENT_UPLOAD_KINDS,
  availableKinds,
  defaultKinds,
  receivedByKind,
} from '../../pages/Public/clientUploadKinds';

const POLL_MS = 10000;
// ÐÐ¾ÐºÐ° Ð¾ÐºÐ½Ð¾ Ð¾ÑÐºÑÑÑÐ¾ Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¶Ð´ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° â ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ ÑÐ°ÑÐµ.
const OPEN_POLL_MS = 3000;

// Ð§ÑÐ¾ ÐºÐ»Ð¸ÐµÐ½Ñ ÑÐ¶Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð» Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ. ÐÐ¿ÑÐ¾Ñ â ÑÑÑÐ°ÑÐ¾Ð²ÐºÐ° Ð½Ð° ÑÐ»ÑÑÐ°Ð¹, ÐµÑÐ»Ð¸ ÑÐ¾ÐºÐµÑ Ð½Ðµ
// Ð´Ð¾ÑÑÐ°Ð²Ð¸Ð» ÑÐ¾Ð±ÑÑÐ¸Ðµ; ÑÐ°Ð¼Ð¾ ÑÐ¾Ð±ÑÑÐ¸Ðµ Ð¸ Ð²Ð¾Ð·Ð²ÑÐ°Ñ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÑÑ ÑÑÐ°Ð·Ñ.
// ÐÐ¾Ð·Ð²ÑÐ°ÑÐ°ÐµÑ [ÑÑÐ¾_Ð¿ÑÐ¸ÑÐ»Ð°Ð½Ð¾, Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÑ_ÑÐµÐ¹ÑÐ°Ñ].
export const useClientUploads = (dealId) => {
  const [received, setReceived] = useState({});

  const refresh = useCallback(() => {
    if (!dealId) return;
    getClientUploadStatus({ dealId })
      .then((res) => setReceived(receivedByKind(res?.data?.files)))
      .catch(() => {});
  }, [dealId]);

  useEffect(() => {
    if (!dealId) return undefined;
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    const onVisible = () => document.visibilityState === 'visible' && refresh();
    const channel = 'listenClientUploadInDeal' + dealId;
    socket.on(channel, refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      socket.off(channel, refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [dealId, refresh]);

  return [received, refresh];
};

const MUTED = '#777';
const GREEN = '#1a8f3c';
const BORDER = '#e2e2e2';

const linkButton = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: 0,
  border: 0,
  background: 'none',
  cursor: 'pointer',
  color: 'var(--brand-primary, #1a73e8)',
  fontSize: 14,
  fontWeight: 600,
};

const outlineButton = {
  background: '#fff',
  color: 'var(--brand-primary)',
  border: '1px solid var(--brand-primary)',
};

const QrIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
    <path d="M14 14h3v3h-3zM20 14v1M14 20h1M18 18h3v3h-3z" />
  </svg>
);

const StatusMark = ({ done }) => (
  <span
    aria-hidden="true"
    style={{
      width: 20,
      height: 20,
      borderRadius: '50%',
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 12,
      color: '#fff',
      background: done ? GREEN : 'transparent',
      border: done ? 'none' : `2px solid ${BORDER}`,
    }}
  >
    {done ? 'â' : ''}
  </span>
);

const OpenLink = ({ file }) => (
  <a href={file.url} target="_blank" rel="noreferrer" style={{ color: 'var(--brand-primary)', fontWeight: 600 }}>
    Ð¾ÑÐºÑÑÑÑ
  </a>
);

// ÐÐ½Ð¾Ð¿ÐºÐ° Ð² ÑÐ°Ð¿ÐºÐµ Ð±Ð»Ð¾ÐºÐ° Â«Ð¡ÐºÐ°Ð½Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²Â» Ð¸ Ð¾ÐºÐ½Ð¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°: Ð²ÑÐ±ÑÐ°ÑÑ, ÑÑÐ¾
// Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ â Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ QR / Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÑÑÐ»ÐºÑ â Ð²Ð¸Ð´ÐµÑÑ, ÑÑÐ¾ ÑÐ¶Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÐºÐ»Ð¸ÐµÐ½Ñ.
const ClientUploadBlock = ({ dealId, phone, showIncome, showWork, received, onRefresh }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(null);
  const [qr, setQr] = useState('');
  const [picked, setPicked] = useState([]);
  const [smsBusy, setSmsBusy] = useState(false);
  const [confirmOff, setConfirmOff] = useState(false);

  useEffect(() => {
    if (!isOpen || !onRefresh) return undefined;
    onRefresh();
    const timer = setInterval(onRefresh, OPEN_POLL_MS);
    return () => clearInterval(timer);
  }, [isOpen, onRefresh]);

  const open = () => {
    setLink(null);
    setConfirmOff(false);
    setPicked(defaultKinds({ showIncome, showWork, received }));
    setIsOpen(true);
  };

  // Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð·Ð°Ð²Ð¸ÑÐ¸Ñ Ð¾Ñ ÑÑÐ°ÑÑÑÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ°; ÐµÑÐ»Ð¸ Ð¾Ð½ ÑÐ¼ÐµÐ½Ð¸Ð»ÑÑ Ð¿ÑÐ¸ Ð¾ÑÐºÑÑÑÐ¾Ð¼ Ð¾ÐºÐ½Ðµ, Ð¾ÑÐ¼ÐµÑÐºÐ¸ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½ÑÑ Ð²Ð¸Ð´Ð¾Ð² Ð¾ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼.
  const available = availableKinds({ showIncome, showWork });
  const pickedAvailable = picked.filter((k) => available.includes(k));

  const toggle = (kind) =>
    setPicked((prev) => (prev.includes(kind) ? prev.filter((k) => k !== kind) : [...prev, kind]));

  const create = async () => {
    setLoading(true);
    try {
      const res = await createClientUploadLink({ dealId, kinds: pickedAvailable });
      setLink(res.data);
      setQr(await QRCode.toDataURL(res.data.url, { width: 360, margin: 1 }));
    } catch (e) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾Ð·Ð´Ð°ÑÑ ÑÑÑÐ»ÐºÑ Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°');
    } finally {
      setLoading(false);
    }
  };

  // ÐÐ¾Ð¼ÐµÑ Ð±ÑÐº Ð±ÐµÑÑÑ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÐ°Ð¼; Ð¾ÑÐ¸Ð±ÐºÐ¸ (Ð»Ð¸Ð¼Ð¸Ñ, Ð½ÐµÑ Ð½Ð¾Ð¼ÐµÑÐ°) Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ Ð¾Ð±ÑÐ¸Ð¹ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº.
  const sendSms = async () => {
    setSmsBusy(true);
    try {
      const res = await sendClientUploadSms({ dealId, kinds: link.kinds });
      alert.success(`Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÑ (Ð½Ð¾Ð¼ÐµÑ Ð½Ð° â¦${res.data.phoneTail})`);
    } catch (e) {
      // ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð¾ Ð² plugins/api
    } finally {
      setSmsBusy(false);
    }
  };

  // ÐÑÐ¸ÑÐ¼ Ð·Ð°ÐºÑÑÑ: ÑÑÑÐ»ÐºÐ° Ð¸ QR Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ, ÑÐ¶Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð½Ð½ÑÐµ ÑÐ°Ð¹Ð»Ñ Ð¾ÑÑÐ°ÑÑÑÑ Ð² Ð°Ð½ÐºÐµÑÐµ.
  const closeLink = async () => {
    try {
      await revokeClientUploadLink({ dealId });
      alert.success('Ð¡ÑÑÐ»ÐºÐ° Ð¾ÑÐºÐ»ÑÑÐµÐ½Ð° â ÐºÐ»Ð¸ÐµÐ½Ñ Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð·Ð°Ð³ÑÑÐ¶Ð°ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ');
      setIsOpen(false);
    } catch (e) {
      // Ð¾ÑÐ¸Ð±ÐºÑ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð» plugins/api
    }
  };

  const copy = () => {
    navigator.clipboard?.writeText(link.url).then(
      () => alert.success('Ð¡ÑÑÐ»ÐºÐ° ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°Ð½Ð°'),
      () => alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐºÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ â Ð²ÑÐ´ÐµÐ»Ð¸ÑÐµ ÑÑÑÐ»ÐºÑ Ð²ÑÑÑÐ½ÑÑ')
    );
  };

  const digits = String(phone || '').replace(/\D/g, '');
  const whatsapp = link
    ? `https://wa.me/${digits}?text=${encodeURIComponent('ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð´Ð»Ñ Ð·Ð°ÑÐ²ÐºÐ¸ (Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÐµ Ñ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°): ' + link.url)}`
    : '';

  // ÐÑÑ, ÑÑÐ¾ Ð¿ÑÐ¾ÑÐ¸Ð»Ð¸ Ð² ÑÑÐ¾Ð¹ ÑÑÑÐ»ÐºÐµ, Ð¿Ð»ÑÑ Ð²ÑÑ, ÑÑÐ¾ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÑÐ°Ð½ÑÑÐµ.
  const shownKinds = link ? ALL_KINDS.filter((k) => link.kinds.includes(k) || received?.[k]) : [];
  const allReceived = !!link && link.kinds.every((k) => received?.[k]);
  const missingTitles = link ? link.kinds.filter((k) => !received?.[k]).map((k) => CLIENT_UPLOAD_KINDS[k].managerTitle) : [];

  if (!dealId) return null;

  return (
    <>
      <button type="button" style={linkButton} onClick={open}>
        <QrIcon />
        ÐÐ°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°
      </button>
      <Modal
        width={480}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        title="ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð¾Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°"
        contentStyle={{ bottom: 'auto', height: 'auto', maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div style={{ display: 'grid', gap: 16 }}>
          {!link ? (
            <>
              <p style={{ margin: 0, color: MUTED }}>
                ÐÐ»Ð¸ÐµÐ½Ñ Ð¾ÑÐºÑÐ¾ÐµÑ ÑÑÑÐ°Ð½Ð¸ÑÑ Ð¿Ð¾ ÑÑÑÐ»ÐºÐµ Ð¸ Ð·Ð°Ð³ÑÑÐ·Ð¸Ñ ÑÐ°Ð¹Ð»Ñ ÑÐ°Ð¼ â Ð¿ÑÑÐ¼Ð¾ ÑÐ¾ ÑÐ²Ð¾ÐµÐ³Ð¾ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°. Ð§ÑÐ¾ Ð½ÑÐ¶Ð½Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ?
              </p>
              <div style={{ display: 'grid', gap: 8 }}>
                {available.map((kind) => (
                  <label
                    key={kind}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      padding: '12px 14px',
                      border: `1px solid ${picked.includes(kind) ? 'var(--brand-primary)' : BORDER}`,
                      cursor: 'pointer',
                    }}
                  >
                    <input type="checkbox" checked={picked.includes(kind)} onChange={() => toggle(kind)} />
                    <span style={{ flex: 1 }}>{CLIENT_UPLOAD_KINDS[kind].managerTitle}</span>
                    {received?.[kind] && (
                      <span style={{ fontSize: 14, color: GREEN }}>
                        â ÑÐ¶Ðµ ÐµÑÑÑ Â· <OpenLink file={received[kind]} />
                      </span>
                    )}
                  </label>
                ))}
              </div>
              <Button type="button" fill full onClick={create} disabled={loading || pickedAvailable.length === 0}>
                {pickedAvailable.length === 0 ? 'ÐÑÐ¼ÐµÑÑÑÐµ ÑÐ¾ÑÑ Ð±Ñ Ð¾Ð´Ð¸Ð½ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ' : 'ÐÐ¾Ð»ÑÑÐ¸ÑÑ ÑÑÑÐ»ÐºÑ Ð¸ QR'}
              </Button>
            </>
          ) : (
            <>
              <div style={{ display: 'grid', justifyItems: 'center', gap: 6 }}>
                {qr && <img src={qr} alt="QR Ð´Ð»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°" style={{ width: 180, height: 180 }} />}
                <span style={{ color: MUTED, fontSize: 14 }}>ÐÐ»Ð¸ÐµÐ½Ñ Ð½Ð°Ð²Ð¾Ð´Ð¸Ñ ÐºÐ°Ð¼ÐµÑÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð½Ð° QR-ÐºÐ¾Ð´</span>
              </div>

              <div style={{ display: 'grid', gap: 8 }}>
                <span style={{ color: MUTED, fontSize: 14 }}>Ð¸Ð»Ð¸ Ð¾ÑÐ¿ÑÐ°Ð²ÑÑÐµ ÑÑÑÐ»ÐºÑ</span>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    readOnly
                    value={link.url}
                    onFocus={(e) => e.target.select()}
                    style={{ flex: 1, minWidth: 0, padding: '0 12px', border: `1px solid ${BORDER}`, font: 'inherit', fontSize: 14 }}
                  />
                  <Button type="button" onClick={copy} style={{ ...outlineButton, padding: '10px 18px' }}>
                    ÐÐ¾Ð¿Ð¸ÑÐ¾Ð²Ð°ÑÑ
                  </Button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: digits ? '1fr 1fr' : '1fr', gap: 8 }}>
                  <Button type="button" full onClick={sendSms} disabled={smsBusy} style={outlineButton}>
                    {smsBusy ? 'ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼â¦' : 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡'}
                  </Button>
                  {digits && (
                    <a href={whatsapp} target="_blank" rel="noreferrer" style={{ display: 'block' }}>
                      <Button type="button" full style={outlineButton}>
                        WhatsApp
                      </Button>
                    </a>
                  )}
                </div>
              </div>

              <div style={{ display: 'grid', gap: 10, paddingTop: 14, borderTop: `1px solid ${BORDER}` }}>
                <b>Ð§ÑÐ¾ Ð¿ÑÐ¸ÑÐ»Ð°Ð» ÐºÐ»Ð¸ÐµÐ½Ñ</b>
                {shownKinds.map((k) => (
                  <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <StatusMark done={!!received?.[k]} />
                    <span style={{ flex: 1 }}>{CLIENT_UPLOAD_KINDS[k].managerTitle}</span>
                    {received?.[k] ? (
                      <span style={{ fontSize: 14, color: GREEN }}>
                        Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾ Â· <OpenLink file={received[k]} />
                      </span>
                    ) : (
                      <span style={{ fontSize: 14, color: MUTED }}>Ð¶Ð´ÑÐ¼ ÐºÐ»Ð¸ÐµÐ½ÑÐ°â¦</span>
                    )}
                  </div>
                ))}
                {allReceived ? (
                  <div style={{ background: '#e6f4ea', padding: '10px 12px', fontSize: 14 }}>
                    ÐÐ»Ð¸ÐµÐ½Ñ Ð¿ÑÐ¸ÑÐ»Ð°Ð» Ð²ÑÑ. Ð¤Ð°Ð¹Ð»Ñ ÑÐ¶Ðµ Ð² Ð°Ð½ÐºÐµÑÐµ â Ð¸Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ Ð² Ð±Ð°Ð½ÐºÐ¸.
                  </div>
                ) : (
                  <span style={{ color: MUTED, fontSize: 14 }}>
                    Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑÑÑ ÑÐ°Ð¼. Ð¡ÑÑÐ»ÐºÐ° Ð´ÐµÐ¹ÑÑÐ²ÑÐµÑ 24 ÑÐ°ÑÐ°.
                  </span>
                )}
              </div>

              {confirmOff ? (
                <div style={{ display: 'grid', gap: 10, background: '#fff6e5', padding: '12px 14px' }}>
                  <span>
                    ÐÐ»Ð¸ÐµÐ½Ñ ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð»: {missingTitles.join(', ')}. ÐÐ¾ÑÐ»Ðµ Ð¾ÑÐºÐ»ÑÑÐµÐ½Ð¸Ñ ÑÑÑÐ»ÐºÐ° Ð¸ QR Ð¿ÐµÑÐµÑÑÐ°Ð½ÑÑ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ;
                    ÑÐ¶Ðµ Ð¿ÑÐ¸ÑÐ»Ð°Ð½Ð½Ð¾Ðµ Ð¾ÑÑÐ°Ð½ÐµÑÑÑ Ð² Ð°Ð½ÐºÐµÑÐµ. ÐÑÐºÐ»ÑÑÐ¸ÑÑ?
                  </span>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <Button type="button" fill onClick={closeLink}>
                      ÐÑÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÐ»ÐºÑ
                    </Button>
                    <Button type="button" onClick={() => setConfirmOff(false)}>
                      ÐÑÐ¼ÐµÐ½Ð°
                    </Button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'grid', gap: 12 }}>
                  {allReceived ? (
                    <Button type="button" fill full onClick={closeLink}>
                      ÐÐ¾ÑÐ¾Ð²Ð¾, Ð·Ð°ÐºÑÑÑÑ ÑÑÑÐ»ÐºÑ
                    </Button>
                  ) : (
                    <Button type="button" fill full onClick={() => setIsOpen(false)}>
                      Ð¡Ð²ÐµÑÐ½ÑÑÑ
                    </Button>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap' }}>
                    <button type="button" style={linkButton} onClick={() => setLink(null)}>
                      ÐÐ·Ð¼ÐµÐ½Ð¸ÑÑ Ð½Ð°Ð±Ð¾Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²
                    </button>
                    {!allReceived && (
                      <button type="button" style={{ ...linkButton, color: MUTED }} onClick={() => setConfirmOff(true)}>
                        ÐÑÐºÐ»ÑÑÐ¸ÑÑ ÑÑÑÐ»ÐºÑ
                      </button>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ClientUploadBlock;
